<template>
<div class="templete_box" style="padding-top:10px;">
    <div class="version_box">
         <div class="version_list">
             <div class="version_search">
                 <div class="inner_box">
                    <el-input class="input" placeholder="请输入内容" v-model="params.keyword" size="small">
                        <i slot="suffix" class="el-input__icon el-icon-search"></i>
                    </el-input>
                    <el-button class="search btn" size="mini" @click="search" v-if="isSearch">查询</el-button>
                    <el-button class="cancel btn" size="mini" @click="reset" v-else>取消</el-button>
                 </div>
             </div>
             <div class="wrap">
                <div v-for="(item, index) in list" :key="index">
                    <div :class="['version_item', item.id == selected_id ? 'actived' : '']"  @click="getDetail(item.id)">
                        <div>
                            <span class="title">{{item.main_title}}</span>
                            <el-rate style="display: inline-block;" v-model="item.star_level" disabled text-color="#ff9900"></el-rate>                      
                        </div>
                        <div class="content">{{item.sub_title}}</div>
                        <div style="text-align: right;">
                            <span class="date">{{item.create_time}}</span>
                        </div>
                        <span v-if="!item.is_see" class="unread">未阅读</span>
                    </div>   
                </div>
             </div>    
         </div>
         <el-drawer></el-drawer>
         <div class="version_detail">
            <div class="detail_header">
                {{main_title}}
             </div>
            <div class="create_time">
                {{create_time}}
            </div>
            <div class="sub_title" :class="{bottomshadow: showShadow}">
                {{sub_title}}
            </div>
            <div ref="content" class="wraper">          
                <div v-html="content" class="content"></div>
            </div>
         </div>
    </div>
</div>
 
</template>

<script>


export default {
    data(){
        return {         
            list: [],
            params: {
                keyword: '',
                page: 1,
                size: 100
            },
            isSearch: true,
            main_title: '',
            sub_title: '',
            content: '',
            create_time: '',
            selected_id: '',
            box: null,
            showShadow: false
        }
    },
    mounted(){
        this.getList()
        this.box = this.$refs.content
        this.box.addEventListener('scroll', ()=>{
            this.showShadow = this.$refs.content.scrollTop > 0 ? true : false
        })
    },
    methods: {
        getList(){
            this.postFunc("erp/bulletin.lst", this.params, res=>{
                let resData = res.data.data.data
                resData.forEach(item => {
                    item.create_time =  this.formatTime(item.create_time*1000)
                });            
                if(resData.length > 0){
                    this.getDetail(resData[0].id) 
                    this.selected_id = resData[0].id
                    resData[0].is_see = 1  
                }else{
                    this.main_title = ''
                    this.sub_title =''
                    this.content = ''
                    this.create_time = ''
                }
                this.list = resData                      
            })
        },
        search(){
            if( this.params.keyword == ''){
                return
            }   
            this.isSearch = false
            this.getList()
        },
        getDetail(id){          
            this.postFunc("erp/bulletin.read", {id}, res=>{
                this.selected_id = id
                let resData = res.data.data
                this.main_title = resData.main_title
                this.create_time = this.formatTime(resData.create_time*1000)
                this.sub_title = resData.sub_title
                this.content = resData.content
                this.list.forEach(item=>{
                    if(item.id == id && item.is_see == 0){
                        item.is_see = 1
                    }
                })
            })
        },
        reset(){
            this.params.keyword = ''
            this.getList()
            this.isSearch = true
        }
    }
}
</script>

<style lang="scss" scoped>
.version_box{
    display: flex;
    height: calc(100% - 5px);
    margin-left: 20px;
    background: #fff;
    box-shadow: 2px -2px 5px #bbb;
    min-width: 1180px;  
    .version_list{
        display: flex;
        flex-direction: column;
        width: 300px;  
        flex-basis: 300px;
        box-shadow: 0px 2px 10px #ccc;  
        cursor: pointer;      
        .version_search{
           margin-top: 10px;
           padding: 10px 0 10px 10px;
           box-sizing: border-box;
           .inner_box{
                display: flex;
                width: 100%;
                padding: 5px 20px 5px 5px;
                background: #eff3f4;
                .input{
                    flex: 1;
                }
                .btn{
                    margin-left: 10px;
                }
           }
        }
        .wrap{
            flex: 1;
            overflow: auto;
            .version_item{  
                position: relative;
                height: 100%;
                width: 100%;
                padding: 20px 10px 20px 25px;
                box-sizing: border-box;
                text-align: left;          
                .title{
                    font-weight: 600;
                    font-size: 14px;
                    margin-right: 10px;
                }
                .date{
                    font-size: 12px;
                }
                .content{
                    width: 100%;
                    font-size: 14px;
                    margin-top: 10px;
                    color: #999;               
                    word-wrap: break-word;
                    word-break: break-all;
                    overflow:hidden;
                    // text-overflow:ellipsis;
                    // white-space:nowrap;
                    // overflow: hidden;
                    box-sizing: border-box;
                }
                .unread{
                    position: absolute;
                    top: 0;
                    left: 0;
                    display: inline-block;
                    padding: 1px 8px;
                    background: #fe4b51;
                    color: #fff;
                    border-top-right-radius: 10px;
                    border-bottom-left-radius: 10px;
                    font-size: 12px;
                }
            }
            .version_item:hover{
                background: #f8f8f8;    
            }
            .actived{
                background: #fff5f5;    
                border: 1px solid #b21111;  
            }
        }     
    }
    .version_detail{
        display: flex;
        flex-direction: column;
        box-shadow: 5px 2px 10px #ccc;
        padding: 10px 20px;
        box-sizing: border-box;
        overflow: auto;
        width: 980px;
        .detail_header{
            padding: 20px;
            border-bottom: 1px solid #eee;
            font-weight: 600;
        }
        .create_time{
            text-align: left;
            margin-top: 20px;
            font-size: 12px;
        }
        .sub_title{
            text-align: left;
            margin-top: 20px;
            font-size: 14px;
            font-weight: 600;
            padding-bottom: 20px;
        }
        .bottomshadow{
           box-shadow:  0 8px 6px -6px #eee;
           z-index: 100;
        }
        .wraper{
            flex: 1;
            overflow: auto;         
            .content{
                width: 100%;
                text-align: left;
                margin-top: 20px;
                /deep/ img{
                    max-width: 100%;
                }
            }  
        }   
    }
}
.version_box /deep/ .el-input__inner:focus {
    border-color: #b21111;
}
.version_box /deep/ .search.el-button--mini {
    background: #b21111;
    border: 1px solid #b21111;
    color: #fff;
}
.version_box /deep/ .cancel.el-button--mini {
    background: #aaa;
    color: #fff;
    border: 1px solid #aaa;
}

.version_box /deep/ .el-rate__icon{
    margin-right: 0px;
}
</style>